import nestingaleLogo from "@/assets/images/logo.svg";
import nestingaleLogoSmall from "@/assets/images/small_logo.png";
import assistantLogo from "@/assets/images/assistant_logo.svg";
import styles from './logo.module.scss';
import React from 'react';

const LogoComponent = (props) => {
    const { brand, footer, isBuilder, isAssistantPage, logoConfig } = props;

    const brandName = brand?.vendorName || brand?.name;
    const isNestingale = !brand || brandName === 'nestingale';

    // CMS-driven logo URLs with local asset fallbacks
    const defaultLogoSrc = logoConfig?.default?.imageUrl || nestingaleLogo.src;
    const smallLogoSrc = logoConfig?.small?.imageUrl || nestingaleLogoSmall.src;
    const assistantLogoSrc = logoConfig?.assistant?.imageUrl || assistantLogo.src;

    // CMS-driven alt text with fallbacks
    const defaultAlt = logoConfig?.default?.alt || 'Nestingale Logo';
    const smallAlt = logoConfig?.small?.alt || 'Nestingale Logo';
    const assistantAlt = logoConfig?.assistant?.alt || 'Nestingale Assistant Logo';

    // CMS-driven assistant label
    const assistantLabel = logoConfig?.assistantLabel?.text || 'Assistant';
    const assistantLabelStyle = logoConfig?.assistantLabel?.style || {
        fontFamily: 'Lora', fontWeight: '500', fontSize: '21px', paddingLeft: '5px', paddingTop: '20px'
    };

    // Choose logo source and alt based on context
    const logoSrc = isAssistantPage ? assistantLogoSrc : (isBuilder ? smallLogoSrc : defaultLogoSrc);
    const logoAlt = isAssistantPage ? assistantAlt : defaultAlt;

    //console.log("--------------Rendering LogoComponent with props:", { brand, footer, isBuilder, isAssistantPage, logoConfig, logoSrc, logoAlt, assistantLabel, assistantLabelStyle });  
  
    return (
      <div className={`${isBuilder ? styles.builderLogo : styles.logo} ${footer ? styles.footer_logo : ''}`}>
      {isNestingale ? (
        <>
        <a href={"/showroom/" + (brand?.vendorName || 'nestingale')} className={styles.logoLink}>
          <img
            src={logoSrc}
            alt={logoAlt}
          />
        </a>
        {isAssistantPage && <span style={assistantLabelStyle}>
          {assistantLabel}
        </span>}
        </>
      ) : (
        // Non-nestingale brand: show only the brand logo (single logo, no nestingale small logo)
        <a href={"/showroom/" + brand.vendorName} className={styles.brand_logo}>
          <img
            alt={logoConfig?.default?.alt || brand.vendorDisplayName || brandName}
            src={logoConfig?.default?.imageUrl || brand.vendorLogo}
            style={{
              objectFit: 'contain',
              ...(logoConfig?.default?.width ? { width: `${logoConfig.default.width}px` } : {}),
              ...(logoConfig?.default?.height ? { height: `${logoConfig.default.height}px` } : {}),
            }}
          />
        </a>
      )}
      </div>
    );
  };
  
  export default LogoComponent;